import { useLocation } from "react-router-dom";
import { useGetHelpContextQuery } from "../../query/helpQuery";
import { helpSiteUrl } from "../../utils/helpSite";
import { useHelpStoreId } from "./useHelpStoreId";

export const useHelpCenterHref = (): string => {
  const location = useLocation();
  const storeId = useHelpStoreId();
  const { data } = useGetHelpContextQuery(location.pathname, storeId);
  return helpSiteUrl(data?.pages[0]?.path ?? "/", storeId);
};
